var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, SyfLoader } from 'syf-component-library/ui/atoms';
import postTransactionEligible from '../../redux/transactionEligible/postTransactionEligible';
import { DisputeFeature } from '../../typings';
import { t } from '../../strings/i18n/i18n';
import { createPortal } from 'react-dom';
import { openModal } from '../../redux/ui/ui.slice';
import { ModalType } from '../../redux/ui/typings';
import { DisputeStatus, LoadingWrapper, NonEligibleForDispute, TransactionEligibilityError } from './subcomponents';
import { STATUS } from './helpers';
var DISPUTE_SUBMISSION_PENDING_ERROR_CODE = '600015';
var TransactionEligible = function (_a) {
    var portalId = _a.portalId;
    var _b = useSelector(function (_a) {
        var appConfig = _a.appConfig, mfeConfig = _a.mfeConfig;
        return ({
            appConfig: appConfig,
            mfeConfig: mfeConfig
        });
    }), _c = _b.appConfig, accountId = _c.accountId, operationId = _c.operationId, returnToParent = _c.returnToParent, apigeeURL = _b.mfeConfig.apigeeURL;
    var _d = useSelector(function (_a) {
        var transactionData = _a.transactionData;
        return transactionData;
    }), referenceNumber = _d.referenceNumber, statementDate = _d.statementDate, transactionAmount = _d.transactionAmount, transactionCode = _d.transactionCode, transactionDate = _d.transactionDate, transactionId = _d.transactionId;
    var isLoading = useSelector(function (_a) {
        var ui = _a.ui;
        return ui;
    }).isLoading;
    var _e = useSelector(function (_a) {
        var transactionEligible = _a.transactionEligible;
        return transactionEligible;
    }), caseId = _e.caseId, eligible = _e.eligible, caseStatus = _e.caseStatus, caseStatusDescription = _e.caseStatusDescription, error = _e.error, isCancelSubmitted = _e.isCancelSubmitted;
    var _f = useState(false), clicked = _f[0], setClicked = _f[1];
    var dispatch = useDispatch();
    var navigateToDispute = function (featureType, modalType) {
        if (featureType === DisputeFeature.Questionnaire) {
            returnToParent(featureType);
            dispatch(openModal(ModalType.Questionnaire));
        }
        else {
            var disputeDetail = {
                modalType: modalType,
                caseId: caseId,
                transactionId: transactionId
            };
            returnToParent(featureType, disputeDetail);
        }
    };
    var handleTransactionEligible = function () {
        setClicked(true);
        dispatch(postTransactionEligible({
            accountId: accountId,
            apiHost: apigeeURL,
            operationId: operationId,
            referenceNumber: referenceNumber,
            statementDate: statementDate,
            transactionCode: transactionCode,
            transactionDate: transactionDate,
            transactionAmount: transactionAmount,
            transactionId: transactionId
        }));
    };
    var renderEligibilityState = function () {
        var _a, _b;
        if (isLoading) {
            return (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) }));
        }
        if (error === null || error === void 0 ? void 0 : error.code) {
            return _jsx(TransactionEligibilityError, {});
        }
        if (caseStatus) {
            return (_jsx(DisputeStatus, { caseStatus: caseStatus, caseStatusDescription: caseStatusDescription, navigateToDispute: navigateToDispute, isCancelSubmitted: isCancelSubmitted }));
        }
        if (((_b = (_a = error === null || error === void 0 ? void 0 : error.businessErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) === DISPUTE_SUBMISSION_PENDING_ERROR_CODE) {
            return (_jsx(DisputeStatus, { caseStatus: STATUS.CLAIM_OPENED_PENDING, caseStatusDescription: caseStatusDescription, navigateToDispute: function () { }, isCancelSubmitted: false }));
        }
        return _jsx(NonEligibleForDispute, {});
    };
    useEffect(function () {
        if (eligible) {
            returnToParent(DisputeFeature.Questionnaire);
            dispatch(openModal(ModalType.Questionnaire));
        }
    }, [dispatch, eligible, returnToParent]);
    return (_jsxs(_Fragment, { children: [!clicked && (_jsx(Button, __assign({ buttonType: "ghost", "data-object": "button", "data-type": "footer", "data-title": "transaction-enrichment", "data-reason": "dispute this transaction", "data-analytics": "clicktrackingevent", "data-cy": "dispute-this-transaction", onClick: handleTransactionEligible }, { children: t('eligibility.disputeThisTransaction') }))), clicked &&
                !eligible &&
                createPortal(renderEligibilityState(), document.getElementById(portalId))] }));
};
export default TransactionEligible;
//# sourceMappingURL=index.js.map